module.exports = __webpack_public_path__ + "static/media/spotlight-banner.422ead57.svg";